export const GAViewCart = () => {
  if (window.itemsInCart) {
    const dataLayer = window.dataLayer || [];
    dataLayer.push({ ecommerce: null });
    dataLayer.push({
      event: "view_cart",
      ecommerce: {
        items: Object.values(window.itemsInCart).map((p) => {
          const itemCategory2 = p.options.metal ? { item_category2: p.options.metal } : {}
          const itemCategory3 = p.options.metal_color ? { item_category3: p.options.metal_color } : {}
          const itemCategory4 = p.options.product_collection ? { item_category4: p.options.product_collection } : {}
          return {
            item_name: p.name,
            item_id: p.options.parent_product.sku,
            price: p.price,
            item_category: p.options.categories,
            item_brand: "1",
            quantity: 1,
            ...itemCategory2,
            ...itemCategory3,
            ...itemCategory4,
          }
        }),
      },
    });
  }
};
